import React from "react";
import { Routes } from "routes/Routes";
import { BrowserRouter as Router } from "react-router-dom";

import { Header } from "components/Header/Header";
import AuthModule from "pages/auth/AuthModule";
import { IAuthAWS } from "interfaces/IAuthAWS";
import {
  IAuthFunctionalities,
  MFAType,
} from "./interfaces/IAuthFunctionalities";
import { AWS_CONFIG } from "./config/config";
import { useAppSelector } from "hooks/reduxHooks";
import DemographicInfo from "pages/auth/DemographicInfo/DemographicInfo";
import { USER_GROUPS } from "constants/roles";
import { selectCurrentClinician } from "./store/ClinicianStore/selectors";

export function App() {
  const config: IAuthAWS = AWS_CONFIG;
  const authConfig: IAuthFunctionalities = {
    RememberDevice: false,
    MFA: MFAType.EMAIL,
  };

  const currentClinician = useAppSelector(selectCurrentClinician);
  const dontHaveAdress =
    !currentClinician?.profileInfo?.address &&
    !currentClinician?.profileInfo?.city;
  if (
    currentClinician &&
    [
      USER_GROUPS.CLINICIAN,
      USER_GROUPS.CLINIC_ADMIN,
      USER_GROUPS.CLINIC_ASSISTANT,
      USER_GROUPS.CLINIC_TEAM_LEAD,
      USER_GROUPS.CLINIC_TEAM_MEMBER,
    ].some((role) => currentClinician.role?.includes(role)) &&
    dontHaveAdress
  ) {
    return (
      <div className="app-container">
        <Router>
          <DemographicInfo />
        </Router>
      </div>
    );
  }

  return (
    <div className="app-container">
      {/* <div className="page-container"> */}
      <Router>
        <AuthModule awsConfig={config} authConfig={authConfig}>
          <Header showSettings />
          {/* <ErrorHandler> */}
          <Routes />
          {/* </ErrorHandler> */}
        </AuthModule>
        <Routes />
      </Router>
      {/* </div> */}
    </div>
  );
}
